/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
*/

import axios from 'axios';
// import QS from 'qs';
import { Message } from "element-ui";


// 环境切换
// if (process.env.NODE_ENV == 'development') {
//   axios.defaults.baseURL = '/api'
// } else if (process.env.NODE_ENV == 'debug') {
//   axios.defaults.baseURL = 'https://dev.vwingist.com'
// } else if (process.env.NODE_ENV == 'production') {
//   axios.defaults.baseURL = 'https://dev.vwingist.com'
// }
const axiosInstance = axios.create({
  timeout: 15000,
  baseURL: process.env.VUE_APP_BASE_API
});
// 请求超时时间
axiosInstance.defaults.timeout = 100001

// post请求头
// 请求拦截
axiosInstance.interceptors.request.use(config => {
  // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
  if (config.headers.requestBase == 'VUE_APP_BASE_API_TWO') {
    config.baseURL = process.env.VUE_APP_BASE_API_TWO; // 取到环境变量：baseURL
  }
  return config;
},
  error => {
    return Promise.error(error)
  }
)

// 响应拦截
axiosInstance.interceptors.response.use(
  response => {

    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况    
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录                
        // 未登录则跳转登录页面，并携带当前页面的路径                
        // 在登录成功后返回当前页面，这一步需要在登录页操作。                
        case 401:
          this.$router.replace({
            path: '/login/1',
            query: { redirect: this.$router.currentRoute.fullPath }
          });
          break;
        // 403 token过期                
        // 登录过期对用户进行提示                
        // 清除本地token和清空vuex中token对象                
        // 跳转登录页面                
        case 403:
          Message.error('登录过期，请重新登录');
          // 清除token                    
          // localStorage.removeItem('token');
          // store.commit('loginSuccess', null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            this.$router.replace({
              path: '/login/1',
              query: {
                redirect: this.$router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;
        // 404请求不存在                
        case 404:
          Message.error('网络请求不存在');
          break;
        // 其他错误，直接抛出错误提示                
        default:
          Message.error('接口请求失败');
      }
      return Promise.reject(error.response);
    }
  }
);

export default axiosInstance;